<template>
    <Layout>
        <PageHeader :title="title" :items="items"></PageHeader>
        <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Doctor" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex justify-content-md-end mt-3 mt-md-0">
                  <button class="btn btn-success" @click="openDoctorCodeModal">
                    <i class="mdi mdi-plus mr-1"></i> Add Doctor Code
                  </button>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData.data"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive
                  class="table-bordered table-hover"
                >
                  <template v-slot:cell(doctor_name)="row">
                    {{ row.item.doctor_name || "-" }}
                  </template>

                  <template v-slot:cell(contact)="row">
                    <div>{{ row.item.mobile_number || "-" }}</div>
                    <small class="text-muted">{{ row.item.email || "" }}</small>
                  </template>

                  <template v-slot:cell(patient_count)="row">
                    {{ row.item.patient_count || 0 }}
                  </template>

                  <template v-slot:cell(diet_plan_count)="row">
                    {{ row.item.diet_plan_count || 0 }}
                  </template>
                </b-table>
              </div>
              <template v-if="tableData.total_pages > 1">
                <div class="data_paginate">

                  <div class="d-flex justify-content-end">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="tableData.total"
                      :per-page="tableData.per_page"
                      first-number
                      last-number
                    ></b-pagination>
                  </div>

                  <div class="form-inline mt-2">
                    <span class="mr-2">Go to page:</span>
                    <b-form-input v-model="pageNo" class="in-width"></b-form-input>
                    <button class="btn btn-search ml-2" @click="filterPage">
                      Go
                    </button>
                  </div>

                </div>
              </template>

              <!-- Add Doctor Code modal -->
              <b-modal
                id="addDoctorCodeModal"
                v-model="doctorCodeModal"
                title="Add Doctor Code"
                hide-footer
                centered
                @hidden="clearDoctorCodeForm"
              >
                <template #modal-title>
                  <i class="mdi mdi-plus-circle-outline mr-1" style="color: #34c38f; font-size: 20px"></i>
                  Add Doctor Code
                </template>
                <div class="col-12">
                  <b-form-group class="col-12">
                    <label style="font-weight: 500">
                      Member <span style="color: red">*</span>
                    </label>
                    <multiselect
                      @search-change="fetchMemberList"
                      v-model="doctorCodeForm.member_id"
                      :options="memberList"
                      :multiple="false"
                      track-by="member_id"
                      label="fnameAndLname"
                      placeholder="Type here to search"
                      :class="{ 'is-invalid': submitted && !doctorCodeForm.member_id }"
                    >
                      <span slot="noOptions"> Type here to search </span>
                    </multiselect>
                    <div v-if="submitted && !doctorCodeForm.member_id" class="invalid-feedback">
                      Member is required.
                    </div>
                  </b-form-group>
                  <b-form-group class="col-12">
                    <label style="font-weight: 500">
                      Doctor Code <span style="color: red">*</span>
                    </label>
                    <b-form-input
                      placeholder="Enter Doctor Code"
                      v-model="doctorCodeForm.doctor_code"
                      maxlength="6"
                      @input="formatDoctorCode"
                      :class="{ 'is-invalid': submitted && !isDoctorCodeValid }"
                    ></b-form-input>
                    <div v-if="submitted && !isDoctorCodeValid" class="invalid-feedback">
                      Doctor code must be 6 characters (MED + 3), e.g. MED123.
                    </div>
                  </b-form-group>
                  <div class="col-12 d-flex justify-content-end">
                    <b-button variant="success btn-sm" @click.prevent="addDoctorCode">
                      Save
                    </b-button>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import MixinRequest from "../../../mixins/request";
import healthSaarthiMixin from "../../../mixins/ModuleJs/health-saarthi-details";

export default {
    data() {
      return {
        title: "Health Saarthi Details",
        sortBy: "doctor_id",
        sortDesc: true,
        items: [
          {
            text: "Home",
            href: "/",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [healthSaarthiMixin, MixinRequest],
    components: {
      Layout,
      PageHeader,
      Multiselect,
    },
  };
</script>
